import request from '@/utils/request';

// 每日分析列表
export const orderDailyAnalysisList = (data: any): any =>
	request({
		url: '/pc/orderDailyAnalysis/List',
		data: data
	})
